const normalize = (text: string): string =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const isSubsequence = (query: string, text: string): boolean => {
  let queryIndex = 0;
  for (const char of text) {
    if (char === query[queryIndex]) {
      queryIndex += 1;
      if (queryIndex === query.length) {
        return true;
      }
    }
  }
  return queryIndex === query.length;
};

export const matchesFuzzyQuery = (text: string, query: string): boolean => {
  const normalizedQuery = normalize(query.trim());
  if (!normalizedQuery) {
    return true;
  }
  const normalizedText = normalize(text);
  return normalizedText.includes(normalizedQuery) || isSubsequence(normalizedQuery, normalizedText);
};
